import { createRouter, createWebHashHistory } from 'vue-router';
import OfficeMapPage from "./components/OfficeMapPage.vue";
import Methodology from "./components/Methodology.vue";
import App from "./App.vue";



const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        { path: "/officemap", component: OfficeMapPage, name: 'OfficeMap', },
        { path: "/home", component: App, name: 'Home' },
        { path: "/methodology", component: Methodology, name: 'Methodology' },
    ]
});

export default router; // Changed to default export